<template>
  <div ref="echarts" id="main" style="width: 100%; height: 100%"></div>
</template>

<script>
export default {
  props: ['myoptions'],
  name: "echarts",
  data() {
    return {
      myChart: null
    }
  },
  name: 'Echarts',
  methods: {
    myEcharts(options) {
      this.myChart = this.$echarts.init(this.$refs.echarts);
      this.myChart.setOption(options, true);
      // window.addEventListener("resize",  () => {

      // });
    },

  },
  mounted() {


  }
}
</script>
<style scoped>
#main > div {
  width: 100%;
  height: 100%;
}
</style>